import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import JelajahiBidang from "@/pages/JelajahiBidang";
import SusunLangkah from "@/pages/SusunLangkah";
import Asesmen from "@/pages/Asesmen";
import HasilAsesmen from "@/pages/HasilAsesmen";
import TryOut from "@/pages/TryOut";
import AdminSoal from "@/pages/AdminSoal";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import RiwayatPembelian from "@/pages/RiwayatPembelian";
import InfoJalur from "@/pages/InfoJalur";
import LatihanOtak from "@/pages/LatihanOtak";
import AdminTryoutUpload from "@/pages/AdminTryoutUpload";
import AdminAsesmenUpload from "@/pages/AdminAsesmenUpload";
import AdminLatihanUpload from "@/pages/AdminLatihanUpload";
import AdminKelolaUpload from "@/pages/AdminKelolaUpload";
import AdminLaporanBulanan from "@/pages/AdminLaporanBulanan";
import AdminProfilSekolah from "@/pages/AdminProfilSekolah";
import AdminSimulasi from "@/pages/AdminSimulasi";
import HasilSimulasi from "@/pages/HasilSimulasi";
import KelolaAkun from "@/pages/KelolaAkun";
import LupaPassword from "@/pages/LupaPassword";
import ResetPassword from "@/pages/ResetPassword";
import InstallPrompt from "@/components/InstallPrompt";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-[#5C5F5C]">Memuat…</div>;
  if (!user) return <Navigate to="/masuk" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/masuk" element={<Auth />} />
            <Route path="/lupa-password" element={<LupaPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/hasil-simulasi" element={<HasilSimulasi />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/jelajahi-bidang" element={<Protected><JelajahiBidang /></Protected>} />
            <Route path="/susun-langkah" element={<Protected><SusunLangkah /></Protected>} />
            <Route path="/asesmen" element={<Protected><Asesmen /></Protected>} />
            <Route path="/profilku" element={<Protected><HasilAsesmen /></Protected>} />
            <Route path="/hasil-asesmen" element={<Navigate to="/profilku" replace />} />
            <Route path="/tryout" element={<Protected><TryOut /></Protected>} />
            <Route path="/riwayat" element={<Protected><RiwayatPembelian /></Protected>} />
            <Route path="/info-jalur" element={<Protected><InfoJalur /></Protected>} />
            <Route path="/latihan-otak" element={<Protected><LatihanOtak /></Protected>} />
            <Route path="/admin/tryout-upload" element={<Protected><AdminTryoutUpload /></Protected>} />
            <Route path="/admin/asesmen-upload" element={<Protected><AdminAsesmenUpload /></Protected>} />
            <Route path="/admin/latihan-upload" element={<Protected><AdminLatihanUpload /></Protected>} />
            <Route path="/admin/kelola-upload" element={<Protected><AdminKelolaUpload /></Protected>} />
            <Route path="/admin/laporan-bulanan" element={<Protected><AdminLaporanBulanan /></Protected>} />
            <Route path="/admin/profil-sekolah" element={<Protected><AdminProfilSekolah /></Protected>} />
            <Route path="/admin/simulasi" element={<Protected><AdminSimulasi /></Protected>} />
            <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
            <Route path="/admin/soal" element={<Protected><AdminSoal /></Protected>} />
            <Route path="/admin/akun" element={<Protected><KelolaAkun /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
        <InstallPrompt />
      </AuthProvider>
    </div>
  );
}

export default App;
